module.exports = __webpack_public_path__ + "static/media/img-booking-available.8e3fa4d4.svg";